/* ═══ LA DERIVA, EN LA PORTADA ══════════════════════════════════════════════
   🔴 ESTE ARCHIVO NACIÓ MAL Y SE CORRIGIÓ EN LA MISMA SESIÓN. Lo escribí como
   un motor nuevo, con su propio atributo y su propia variable (`--s`), y al ir
   a la siguiente sección apareció que EL PROYECTO YA TENÍA UNO: `biblio.js`
   generaliza el paralaje sobre `[data-deriva]` desde la tanda de la
   biblioteca, con la misma fórmula. Dos dueños para el mismo gesto es el error
   que este código ya documenta en §3 y en el acento del manifiesto, y lo
   volví a cometer.

   Lo que SÍ era cierto del diagnóstico: en `index.html` hay **cero**
   `data-deriva` y `biblio.js` **no se carga** aquí. O sea que el motor existía
   y la portada no lo usaba — por eso medí cero movimiento enganchado al scroll
   fuera del hero. El hueco era real; el archivo nuevo, no.

   Así que esto deja de ser un motor rival y pasa a ser el MISMO motor para las
   páginas que no cargan `biblio.js`: mismo atributo `data-deriva`, misma
   variable `--deriva`, mismo signo y mismo rango. El CSS que se escriba aquí
   funciona igual en la biblioteca sin tocar una línea.

       +1  el bloque está arriba del todo (acaba de salir por arriba)
        0  su centro está en el centro de la pantalla
       −1  acaba de asomar por abajo

   Tres decisiones que no son de gusto:

   · SE ESCUCHA EL SCROLL, no se corre un rAF perpetuo. Un bucle abierto quema
     batería aunque nadie mueva la rueda. Cada evento agenda UN fotograma y se
     apaga solo. Lenis empuja `scrollTop` de verdad, así que el evento nativo
     sigue llegando.

   · SOLO SE MIDE LO QUE ESTÁ A LA VISTA, con un observador. Un
     `getBoundingClientRect()` por pieza y por fotograma sobre toda la página
     costaría reflow; así el conjunto activo son dos o tres.

   · MOVIMIENTO REDUCIDO Y PESTAÑA OCULTA APAGAN EL MOTOR, pero dejando
     `--deriva` en 0 — que es el reposo. Si se quedara sin definir, cada
     `calc()` contra una variable vacía invalidaría su declaración entera y la
     pieza se vería mal sin un solo error en consola.                         */

/* ── el ancho REAL de la barra de scroll ────────────────────────────────────
   `100vw` la incluye; `100%` no. Cualquier sangrado a pantalla completa hecho
   con `100vw` se pasa del viewport donde se reserva barra (Windows, y macOS
   con "mostrar siempre") y aparece scroll horizontal. Reservar 20 px a ojo
   deja la pieza corta justo donde NO hay barra, que es el caso normal en Mac,
   y un sangrado que se queda a diez píxeles del borde no lee a decisión: lee a
   error de cálculo. Se mide y se publica.
   Va aquí porque es fontanería de maquetación y no merece un archivo propio. */
(() => {
  const mide = () => document.documentElement.style.setProperty(
    '--barra', (innerWidth - document.documentElement.clientWidth) + 'px');
  mide();
  addEventListener('resize', mide);
})();

(() => {
  /* Si `biblio.js` ya corre en esta página, él manda: no se montan dos. */
  if (window.__deriva) return;

  const piezas = document.querySelectorAll('[data-deriva]');
  if (!piezas.length) return;
  window.__deriva = true;

  const quieto = matchMedia('(prefers-reduced-motion: reduce)');
  const vivas  = new Set();
  let pedido   = false;

  const reposo = () => piezas.forEach(el => el.style.setProperty('--deriva', '0'));
  reposo();   /* el reposo se pone SIEMPRE, aunque el motor no llegue a arrancar */

  const pinta = () => {
    pedido = false;
    const alto = innerHeight;
    vivas.forEach(el => {
      const r = el.getBoundingClientRect();
      /* Idéntica a la de `biblio.js`, hasta el signo: el centro del bloque
         contra el centro de la ventana, normalizado por el recorrido completo
         que hace de asomar a salir. Con esto un bloque alto y uno bajo
         recorren el mismo rango −1..1 y la hondura del CSS significa lo mismo
         en los dos. */
      const d = (alto / 2 - (r.top + r.height / 2)) / (alto / 2 + r.height / 2);
      el.style.setProperty('--deriva', (d < -1 ? -1 : d > 1 ? 1 : d).toFixed(4));
    });
  };

  const agenda = () => {
    if (pedido || !vivas.size || quieto.matches || document.hidden) return;
    pedido = true;
    requestAnimationFrame(pinta);
  };

  const ojo = new IntersectionObserver(entradas => {
    entradas.forEach(e => e.isIntersecting ? vivas.add(e.target) : vivas.delete(e.target));
    agenda();
  }, { rootMargin: '15% 0px 15% 0px' });
  piezas.forEach(el => ojo.observe(el));

  addEventListener('scroll', agenda, { passive: true });
  addEventListener('resize', agenda);
  document.addEventListener('visibilitychange', agenda);
  quieto.addEventListener('change', () => quieto.matches ? reposo() : agenda());

  agenda();
})();
